/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "react-modal";
import Swal from "sweetalert2";
import "@github/relative-time-element";
import { FaEdit } from "react-icons/fa";
import { MdOutlineClose } from "react-icons/md";
import axios from "axios";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import EditSlas from "./edit-slas/edit-slas";

Modal.setAppElement("#root");

function SLA() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [slas, setSlas] = useState([]);
  const [id, setId] = useState({});
  const [services, setServices] = useState([]);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [slasPerPage, setSlasPerPage] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [escal, setEscal] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [esca, setEsca] = useState(0);

  const getData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_slas`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        const sorted = res.data.data.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });
        setSlas(sorted);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getDataServices = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_services`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setServices(res.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getData();
    getDataServices();
  }, [updateTrigger]);

  useEffect(() => {
    setEsca(esca);
  }, [esca]);

  const filteredSlas = searchValue
    ? slas.filter((slas) =>
        slas.name.toUpperCase().includes(searchValue.toUpperCase())
      )
    : slas;

  const indexOfLastUser = currentPage * slasPerPage;
  const indexOfFirstUser = indexOfLastUser - slasPerPage;
  const currentSlas = filteredSlas.slice(indexOfFirstUser, indexOfLastUser);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPageCount = Math.ceil(filteredSlas.length / slasPerPage);
  const pageNumbers = [];
  const maxPageNumbersToShow = 20;

  let startPage, endPage;
  if (totalPageCount <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPageCount;
  } else {
    startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow) {
      startPage = endPage - maxPageNumbersToShow + 1;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const showEntries = (e) => {
    setSlasPerPage(e.target.value);
  };

  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };

  const getNameService = (id) => {
    const servicio = services.filter((data) => data.id === id);
    if (servicio.length > 0) {
      return servicio[0].name;
    }
    return id;
  };

  const deleteSlas = async (id) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "Seguro que desea eliminar este SLA?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        const res = await axios.get(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_slas/destroy/${id}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );

        if (res.data.code === 1) {
          Swal.fire("¡Eliminado!", "El SLA ha sido eliminado.", "success");
          setUpdateTrigger(!updateTrigger);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "No se realizo ninguna acción", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const openModal = (id) => {
    setId(id);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setUpdateTrigger(!updateTrigger);
  };

  return (
    <>
      <ScrollToTop />
      <div className="table-responsive">
        <div
          className="dataTables_wrapper dt-bootstrap4 no-footer"
          id="datatables_wrapper"
        >
          <div className="row justify-content-between mb-2">
            <div className="col-sm-12 col-md-4">
              <div className="dataTables_length" id="dataTables_length">
                <label className="d-flex justify-content-end">
                  <span className="mr-2 p-2">Mostrar</span>
                  <select
                    name="datatables_length"
                    aria-controls="datatables_length"
                    className="custom-select custom-select-sm form-control-sm narrow-select p-2"
                    onChange={showEntries}
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <span className="ml-2 p-2">Registros</span>
                </label>
              </div>
            </div>
            <div className="col-sm-12 col-md-4">
              <div className="datatables_filter" id="datatables_filter">
                <label className="d-flex justify-content-end">
                  <span className="mr-2 mt1 p-2">Buscar</span>
                  <input
                    type="search"
                    id="searchInput"
                    className="form-control form-control-sm"
                    placeholder
                    aria-controls="datatables"
                  />
                  <button className="btn-amc-blue ml-2" onClick={handleSearch}>
                    Buscar
                  </button>
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <table
                className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                role="grid"
                aria-describedby="datatables_info"
              >
                <thead>
                  <tr role="row">
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "81.2031px" }}
                    >
                      ID
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "178.203px" }}
                    >
                      Nombre
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "180.766px" }}
                    >
                      Servicio
                    </th>
                    <th
                      className="sorting"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "159.453px" }}
                    >
                      Creado
                    </th>
                    <th
                      className="sorting_disabled"
                      tabIndex={0}
                      aria-controls="datatables"
                      rowSpan={1}
                      colSpan={1}
                      style={{ width: "161.125px" }}
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentSlas.map((slas) => (
                    <tr key={slas.id}>
                      <td>{slas.id}</td>
                      <td>{slas.name}</td>
                      <td>{getNameService(slas.notification_service_id)}</td>
                      <td>
                        <relative-time
                          datetime={"2024-05-02 16:25:53"}
                          lang="es"
                        />
                      </td>
                      <td>
                        <FaEdit
                          className="btn-edit"
                          onClick={() => {
                            openModal(slas.id);
                          }}
                        />
                        <MdOutlineClose
                          className="btn-delete"
                          onClick={() => {
                            deleteSlas(slas.id);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <nav aria-label="Page navigation example">
              <ul className="pagination">
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Anterior
                  </button>
                </li>
                {pageNumbers.map((pageNumber) => (
                  <li className="page-item" key={pageNumber}>
                    <button
                      className="page-link"
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                ))}
                <li className="page-item">
                  <button
                    className="page-link"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === pageNumbers.length}
                  >
                    Siguiente
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Edit Modal"
          style={{
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
              maxHeight: "90vh",
              overflowY: "auto", // Añadir el scroll
            },
          }}
        >
          <EditSlas id={id} close={closeModal} />
        </Modal>
      </div>
    </>
  );
}

export default SLA;
